import styled from 'styled-components';
import { flexBox } from '../../mixins';
import leftArrow from 'assets/icons/left-arrow.svg';

export const HeaderContainer = styled.header`
  width: 100%;
  height: 8.75vh;
  min-height: ${({ theme }) => theme.config.headerHeight};
  text-align: -webkit-center;
  position: sticky;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.colors.primary.main};
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.06);
  z-index: 1000;

  /* IOS Only */
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
`;

export const HeaderInner = styled.div`
  /* ${flexBox('row', 'flex-start', 'center')}; */
  max-width: 640px;
  margin: auto;
  width: 100%;
  height: 100%;
`;

export const HeaderContentWrapper = styled.div`
  ${flexBox('row', 'space-between', 'center', '8px')};
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  height: 100%;
`;

export const Arrow = styled.img`
  width: 18px;
  height: 12px;
`;

Arrow.defaultProps = {
  src: leftArrow,
};

export const Logo = styled.img`
  width: auto;
  height: 37%;
`;

export const Nav = styled.nav`
  ${flexBox('row', 'space-between', 'center', '3.8vw')};
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  list-style: none;
  padding-right: 20px;

  > * {
    cursor: pointer;
  }
`;
